module.exports = __webpack_public_path__ + "VIPH6.png?78c806ad9c618d80e39e39be0f49873a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH6.png
// module id = 99
// module chunks = 0